import { Controller, useFormContext } from 'react-hook-form';
import { TreeSelect, TreeSelectProps } from 'antd';
import { useState } from 'react';
import generateKey from '../../utils/generateKey';

interface FormTreeSelectProps extends TreeSelectProps {
  name: string;
  children: React.ReactNode;
  handleOnChange?: (current: string, prev: string[]) => string | string[];
}

export const FormTreeSelect = ({ name, children, multiple, handleOnChange, ...props }: FormTreeSelectProps) => {
  const { control } = useFormContext();
  const [key, setKey] = useState('');

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => {
        const handleOnSelect = (current: string) => {
          let newData: string | string[] = current;

          if (handleOnChange) {
            newData = handleOnChange(current, value);
          }

          onChange(newData);
        };

        const handleOnDeSelect = (current: string) => {
          if (!multiple) {
            return onChange('');
          }

          onChange(value.filter((o: string) => o !== current));
        };

        return (
          <TreeSelect
            key={key}
            multiple={multiple}
            onSelect={handleOnSelect}
            onDeselect={handleOnDeSelect}
            onClear={() => onChange('')}
            onBlur={() => setKey(generateKey())}
            value={value}
            {...props}
          >
            {children}
          </TreeSelect>
        );
      }}
    />
  );
};
